/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { ProjectContext } from '.';

export const useProject = () => {
  return React.useContext(ProjectContext);
};
